import React from "react";
import Howto from "./Howto";
import { poolTypeById } from "../poolTypes";

const HowtoPage = ({ pool_id }) => {
  return (
    <div className="row second">
      <div className="large-12 columns" style={{ paddingLeft: "0.3em" }}>
        <Howto poolType={poolTypeById(pool_id)} />
      </div>
    </div>
  );
};

export default HowtoPage;
